module.exports = __webpack_public_path__ + "assets/9d03c0a2c80248e384d20398e4629272.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/pickbonus/Reveal.mp3
 ** module id = 219
 ** module chunks = 0
 **/